// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mKB56b {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: calc(100vh - 68px);
  margin: 0 -24px;
  width: calc(100% + 48px);
}
.sbFL7X {
  background: linear-gradient(90deg, #e1e1e1, #eaeaea);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.sbFL7X img {
  width: 74%;
  height: auto;
  border-radius: 10px;
}
.cjitFi {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-3);
  background: var(--surface-neutral-pale);
  padding: var(--spacing-3);
}
.cjitFi > :first-child {
  width: 32px;
  height: 32px;
}
.cjitFi h1 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-regular);
  margin: 0;
}
.LomZPB {
  width: 350px;
  max-width: 100%;
}
.fj6Dnx {
  --benefits-timeline-item-min-height: 32px;
  --benefits-timeline-last-item-min-height: 20px;
  --benefits-timeline-item-padding-bottom: 0px;
  --benefits-timeline-connector-top: 16px;
  --benefits-timeline-connector-height: 16px;
}
@media (max-width: 767px) {
  .mKB56b {
    grid-template-columns: 1fr;
  }
  .sbFL7X {
    min-height: 250px;
  }
  .sbFL7X img {
    max-width: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/BenefitMigrationTrackingPage/BenefitMigrationTrackingPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,oDAAoD;EACpD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;EACvC,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,SAAS;AACX;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,8CAA8C;EAC9C,4CAA4C;EAC5C,uCAAuC;EACvC,0CAA0C;AAC5C;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  min-height: calc(100vh - 68px);\n  margin: 0 -24px;\n  width: calc(100% + 48px);\n}\n.illustration {\n  background: linear-gradient(90deg, #e1e1e1, #eaeaea);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n.illustration img {\n  width: 74%;\n  height: auto;\n  border-radius: 10px;\n}\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-3);\n  background: var(--surface-neutral-pale);\n  padding: var(--spacing-3);\n}\n.content > :first-child {\n  width: 32px;\n  height: 32px;\n}\n.content h1 {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-regular);\n  margin: 0;\n}\n.card {\n  width: 350px;\n  max-width: 100%;\n}\n.timeline {\n  --benefits-timeline-item-min-height: 32px;\n  --benefits-timeline-last-item-min-height: 20px;\n  --benefits-timeline-item-padding-bottom: 0px;\n  --benefits-timeline-connector-top: 16px;\n  --benefits-timeline-connector-height: 16px;\n}\n@media (max-width: 767px) {\n  .layout {\n    grid-template-columns: 1fr;\n  }\n  .illustration {\n    min-height: 250px;\n  }\n  .illustration img {\n    max-width: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `mKB56b`,
	"illustration": `sbFL7X`,
	"content": `cjitFi`,
	"card": `LomZPB`,
	"timeline": `fj6Dnx`
};
module.exports = ___CSS_LOADER_EXPORT___;
